import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProspects = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		transform: "translate(1.2 0) scale(1.2)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M14.6824 1.6665H3.31764C1.86834 1.6665 1.00388 3.26279 1.80781 4.45453L6.57589 10.6894C6.97333 11.2785 7.18541 11.9708 7.18541 12.6789V17.4347C7.18541 18.2336 8.16269 18.6336 8.73426 18.0688L10.5489 16.2755C10.719 16.1073 10.8146 15.8792 10.8146 15.6414V12.6789C10.8146 11.9708 11.0267 11.2785 11.4241 10.6894L16.1922 4.45453C16.9961 3.26279 16.1317 1.6665 14.6824 1.6665Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	})]
});
const ForwardRef = forwardRef(SvgProspects);
export default ForwardRef;
